<div class="quadroGeral" [ngClass]="{'print-page':print}">
  <nav class="tabs-container nav-menu" *ngIf="!print">
    <ul class="nav nav-tabs" role="tablist">
      <li >
        <a [class.active]="currentPage == 'status'" (click)="changePage('status')">
          <img  [src]="statusFile" type="image/svg+xml">
          Projetos
        </a>
      </li>
      <li >
        <a [class.active]="currentPage == 'projection'" (click)="changePage('projection')">
          <img  [src]="statusProjection" type="image/svg+xml">
          Indicadores
        </a>
      </li>
    </ul>
  </nav>
  <article class="body-item back-white" *ngIf="currentPage == 'status' || print">

    <div class="body-chart row g-0">
      <section class="col-sm-2 section-labels p-2">
        <h3>
          Projetos
        </h3>
        <ul class="" >
          <li *ngFor="let agency of orderAgencies() | keyvalue" class="agency-item">
            <h4>{{agency?.value?.label}}</h4> <span>{{agency?.value?.total}} {{agency?.value?.total>1?'projetos': 'projeto'}}</span>
          </li>
          <hr class="my-3">
          <li class="agency-item mt-0 agency-sum">  
            <h5>TOTAL </h5>
            <span>{{getTotalProjects()}} {{getTotalProjects() ?? 0 > 1? 'projetos': 'projeto'}}</span>
            </li>
        </ul>
      </section>
      <section class="col-sm-10 div-chart row g-0  p-2 pb-4">
        <div class="col-sm-10 chart-div">
          <h3 class="w-100">
            Status dos Projetos
          </h3>
          <img *ngIf="print" id="img_chart1">
          <canvas baseChart  id="chart1" class="chart chart-item status-chart" [data]="statusChart?.data" [options]="statusChart?.options" 
          [type]="statusChart?.type" [plugins]="statusChart?.plugins" [height]="print?  150: ''" [width]="print? 150: ''"></canvas>
        </div>
        <div class="col-sm-2 label-div">
          <section class="label-chart">
            <ul>
              <li *ngFor="let item of statusLabel">
                <div class="dot" [ngStyle]="{'background-color': item.backgroundColor}"></div>
                <span class="me-1">{{item.label}}</span>
                
              </li>
            </ul>
          </section>
        </div>
      </section>
    </div>
  </article>
  <br *ngIf="print">
  <article class="body-item" *ngIf="currentPage == 'projection' || print">
    <div class="row g-0"> 
      <section class="col-md-6 pe-0 pe-md-2 pb-md-0"  [ngClass]="{'pb-2': !print}"> 
        <div class="section-bar div-expand">
          <h3>
            Atingimento de Metas
          </h3>
          <div class="body-chart ">
            <div *ngFor="let chart of achievementChart; let i = index" class="mt-2">
              <mat-accordion class="example-headers-align mb-0" [togglePosition]="'before'">
                <mat-expansion-panel class="session mb-0" [expanded]="true">
                  <mat-expansion-panel-header  class="session-title  py-2 " *ngIf="!print">
                    <mat-panel-title class="d-flex justify-content-between row">
                      <div class=" d-flex">
                        <h4>{{chart?.data?.labels[0]}}</h4> <span *ngIf="countDataChart(chart?.data) as total">{{total}} {{total>1?'Metas': 'Meta'}}</span>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <canvas baseChart id="chart2-{{i}}" class="chart chart-bar chart-item" [data]="chart?.data" [options]="chart?.options" 
                    [type]="chart?.type" [plugins]="chart?.plugins" [height]="print? 40: ''" [width]="print? 240: ''"></canvas>
                </mat-expansion-panel>
              </mat-accordion>
              <div class="session-title mt-1" *ngIf="print">
                <div class=" d-flex" *ngIf="countDataChart(chart?.data) as total">
                  <h4>{{chart?.data?.labels[0]}}</h4> <span>{{total}} {{total>1?'Metas': 'Meta'}}</span>
                </div>
                <img id="img_chart2-{{i}}">
              </div>
            </div>
          </div>
          <hr class="mt-2 mb-2">
          <div class="label-chart-bar">
            <ul class="label-bar-chart">
              <li *ngFor="let item of patternAchievement">
                <div class="dot" [ngStyle]="{'background-color': item.color}"></div>
                <span class="me-2">{{item.label}}</span>
              </li>
            </ul>
          </div>
          <hr class="space-expand">
        </div>
      </section>
      <section class="col-md-6 ps-0 ps-md-2 pt-md-0" [ngClass]="{'pt-2': !print}"> 
        <div class="section-bar div-expand">
          <h3>
            Projeção das Metas
          </h3>
          <div class="body-chart ">
            <div *ngFor="let chart of projectionChart; let i = index" class="mt-2">
              <mat-accordion class="example-headers-align mb-0" [togglePosition]="'before'">
                <mat-expansion-panel class="session mb-0" [expanded]="true">
                  <mat-expansion-panel-header  class="session-title  py-2 "  *ngIf="!print">
                    <mat-panel-title class="d-flex justify-content-between row">
                      <div class=" d-flex" *ngIf="countDataChart(chart?.data) as total">
                        <h4>{{chart?.data?.labels[0]}}</h4> <span>{{total}} {{total>1?'Metas': 'Meta'}}</span>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <canvas baseChart id="chart3-{{i}}" class="chart chart-bar chart-item" [data]="chart?.data"  [options]="chart?.options" 
                    [type]="chart?.type" [plugins]="chart?.plugins" [height]="print? 40: ''" [width]="print? 240: ''"></canvas>
                </mat-expansion-panel>
              </mat-accordion>
              <div class="session-title" *ngIf="print">
                <div class=" d-flex" *ngIf="countDataChart(chart?.data) as total">
                  <h4>{{chart?.data?.labels[0]}}</h4> <span>{{total}} {{total>1?'Metas': 'Meta'}}</span>
                </div>
                <img id="img_chart3-{{i}}">
              </div>
              
            </div>
          </div>
          <hr class="mt-2 mb-2"> 
          <div class="label-chart-bar">
            <ul class="label-bar-chart row g-0">
              <li *ngFor="let item of patternProjection" class="col-md-6">
                <div class="dot" [ngStyle]="{'background-color': item.color}"></div>
                <span class="me-2">{{item.label}}</span>
              </li>
            </ul>
          </div>
          <hr class="space-expand">
        </div>
      </section>
    </div>
  </article>
 
  </div>

<app-loading [loader]="isLoading"></app-loading>